// Eğitim Raporları / Eğitim Yönetimi tablolarının sütunları. Metinler:
// educationReports.columns.<key>. Eğitim Yönetimi (SMO görünümü) projeleri ve
// departmanı da gösterir.

const BASE_COLUMNS = {
  name: { type: 'text', width: 240 },
  role: { type: 'select', width: 200 },
  progress: { width: 230 },
  status: { width: 150 },
  sop: { width: 110 },
  training: { width: 110 },
  overdue: { width: 120 },
  email: { width: 240 },
};

const SMO_COLUMNS = {
  name: { type: 'text', width: 240 },
  project: { type: 'select', width: 220 },
  role: { type: 'select', width: 190 },
  department: { type: 'select', width: 180 },
  progress: { width: 230 },
  status: { width: 150 },
  sop: { width: 110 },
  training: { width: 110 },
  overdue: { width: 120 },
  email: { width: 240 },
};

const buildConfig = (columns, hidden) => {
  const keys = Object.keys(columns);
  return {
    columns,
    keys,
    defaultVisible: { ...Object.fromEntries(keys.map((key) => [key, true])), ...Object.fromEntries(hidden.map((key) => [key, false])) },
    filterKeys: keys.filter((key) => columns[key].type),
  };
};

/** Column set of a report mode: 'all' (Eğitim Raporları) or 'smo' (Eğitim Yönetimi). */
export const REPORT_CONFIGS = {
  all: buildConfig(BASE_COLUMNS, ['email']),
  smo: buildConfig(SMO_COLUMNS, ['email']),
};

export const REPORT_COLUMNS = BASE_COLUMNS;
export const COLUMN_KEYS = REPORT_CONFIGS.all.keys;
export const DEFAULT_VISIBLE_COLUMNS = REPORT_CONFIGS.all.defaultVisible;
export const FILTER_KEYS = REPORT_CONFIGS.all.filterKeys;
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['name'];

export const STATUSES = ['completed', 'inProgress', 'notStarted'];
export const ALL_STATUSES = 'all';
export const SCOPES = ['all', 'SOP', 'Eğitim'];

// Excel dosyası Türkçe kalır
export const STATUS_EXCEL = { completed: 'Tamamlandı', inProgress: 'Devam Ediyor', notStarted: 'Başlanmadı' };

export const EMPTY_FILTERS = { name: '', role: '', project: '', department: '' };

export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
